import {
  CompanyTransportOption,
  TransportType,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kCompany } from "./company";

export const kTransportOptions: CompanyTransportOption[] = [
  {
    id: "5352b1e8-47e6-490f-b4f6-676a35c4b818",
    companyId: kCompany.id,
    type: "user_car" as TransportType,
    name: "Electric car",
  },
  {
    id: "150dcf98-869d-47df-a0ae-48a0bec4e3dd",
    companyId: kCompany.id,
    type: "public_transport" as TransportType,
    name: "Bus",
  },
  {
    id: "4ad359d6-3440-48ee-8b12-0d28b27be9fb",
    companyId: kCompany.id,
    type: "public_transport" as TransportType,
    name: "Subway",
  },
  {
    id: "5b6fadaf-78db-4d85-9b8a-2dd349b6a6de",
    companyId: kCompany.id,
    type: "walk" as TransportType,
    name: "Walk",
  },
  {
    id: "6a51b6d1-afbc-4c10-92d8-259a6ab96e0b",
    companyId: kCompany.id,
    type: "bicycle" as TransportType,
    name: "Bike",
  },
];
